import { Button } from "@dune/ui";
import { Plus } from "@untitled-ui/icons-react";
import React from "react";
import { useNavigate } from "react-router-dom";

import { PAGES } from "@dune/types";

const GFAList: React.FC = () => {
	const navigate = useNavigate();

	const handleCreateNew = () => {
		navigate(PAGES.GFA.create);
	};

	return (
		<div className="flex flex-col p-4 gap-4">
			<div className="flex flex-row justify-between">
				<div className="text-lg font-semibold">Projets</div>
				<Button onClick={handleCreateNew}>
					<Plus className="mr-2" /> Nouveau projet
				</Button>
			</div>
		</div>
	);
};

export default GFAList;
